module.exports = __webpack_public_path__ + "img/크루세이더.8e43eab8.png";